var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "shareModal",
      staticClass: "modal fade",
      attrs: {
        id: "shareModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "exampleModalLabel",
        "aria-hidden": "true",
        "data-backdrop": "static",
        "data-keyboard": "false",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "h5",
              {
                staticClass: "modal-title",
                attrs: { id: "exampleModalLabel" },
              },
              [_vm._v(_vm._s(_vm.__("question.convert")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "prve",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  },
                },
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body form-group" }, [
            _c("div", { staticClass: "mb-05" }, [
              _c(
                "label",
                { staticClass: "required", attrs: { for: "question_title" } },
                [_vm._v("Question Title")]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.question_title,
                    expression: "question_title",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.question_title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.question_title = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              this.errors.question_title != null
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-left text-danger help-block font-small-1",
                      attrs: { role: "alert" },
                    },
                    [
                      _c("i", { staticClass: "feather icon-x-circle" }),
                      _vm._v(
                        " " +
                          _vm._s(this.errors.question_title[0]) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mb-05" }, [
              _c(
                "label",
                {
                  staticClass: "required d-block",
                  attrs: { for: "question_body" },
                },
                [_vm._v("Question Text")]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card my-0 d-none", attrs: { id: "editor" } },
                [
                  _c(
                    "div",
                    [
                      _c("editor", {
                        attrs: {
                          "api-key": "no-api-key",
                          init: {
                            skin: "trybz-member",
                            skin_url: "/plugins/tiny-mce-skin/ui/trybz-member",
                            content_css:
                              "/plugins/tiny-mce-skin/content/trybz-member/content.min.css",
                            external_plugins: {
                              customtags:
                                "/plugins/tiny-mce-plugins/customtags/plugin.min.js",
                              loadingbar:
                                "/plugins/tiny-mce-plugins/loadingbar/plugin.min.js",
                            },
                            valid_elements:
                              "p,br,b,i,b/strong,i/em,a[href|target=_blank],li[a|b|i|u|ol|ul],ol[li],ul[li]",
                            plugins:
                              "link quickbars autolink lists customtags loadingbar autoresize",
                            link_context_toolbar: true,
                            quickbars_selection_toolbar:
                              "bold italic link bullist",
                            quickbars_image_toolbar: false,
                            quickbars_insert_toolbar: false,
                            link_assume_external_targets: "https",
                            link_target_list: false,
                            link_title: false,
                            toolbar: false,
                            branding: false,
                            elementpath: false,
                            menubar: false,
                            max_height: 300,
                            file_picker_types: "",
                            content_style:
                              "body { font-family: Montserrat, Helvetica, Arial, serif; font-size: 0.86rem; font-weight: 400; line-height: 1.45; color: #1d2124; }",
                            relative_urls: false,
                            remove_script_host: false,
                            init_instance_callback: this.loader,
                          },
                        },
                        model: {
                          value: _vm.question_text,
                          callback: function ($$v) {
                            _vm.question_text = $$v
                          },
                          expression: "question_text",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              this.errors.question_body != null
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-left text-danger help-block font-small-1",
                      attrs: { role: "alert" },
                    },
                    [
                      _c("i", { staticClass: "feather icon-x-circle" }),
                      _vm._v(
                        " " +
                          _vm._s(this.errors.question_body[0]) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.tags.length > 0
              ? _c("div", { staticClass: "mb-05 w-100" }, [
                  _c("label", {}, [
                    _vm._v(_vm._s(_vm.__("question.field.text.tags"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selected_question_tags,
                          expression: "selected_question_tags",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { id: "tags" + this._uid, multiple: "multiple" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selected_question_tags = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.tags, function (tag) {
                      return _c("option", { domProps: { value: tag.id } }, [
                        _vm._v(_vm._s(tag.name)),
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  this.errors.question_tags != null
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "text-left text-danger help-block font-small-1 ",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("i", { staticClass: "feather icon-x-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(this.errors.question_tags[0]) +
                              "\n                         "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mb-05 w-100" }, [
              _c("label", { staticClass: "required" }, [
                _vm._v(_vm._s(_vm.__("question.field.text.service_label"))),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.service,
                      expression: "service",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "service" + this._uid },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.service = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "profile", selected: "" } }, [
                    _vm._v(_vm._s(_vm.__("globals.your_newsfeed"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "optgroup",
                    { attrs: { label: _vm.__("globals.share_group") } },
                    _vm._l(_vm.groups_followed, function (group) {
                      return _c(
                        "option",
                        { domProps: { value: "group_" + group.id } },
                        [_vm._v(_vm._s(group.title))]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "optgroup",
                    { attrs: { label: _vm.__("globals.share_supplier") } },
                    _vm._l(_vm.suppliers_followed, function (supplier) {
                      return supplier.enable_faqs === 1
                        ? _c(
                            "option",
                            { domProps: { value: "supplier_" + supplier.id } },
                            [_vm._v(_vm._s(supplier.title))]
                          )
                        : _vm._e()
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              this.errors.service != null
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-left text-danger help-block font-small-1",
                      attrs: { role: "alert" },
                    },
                    [
                      _c("i", { staticClass: "feather icon-x-circle" }),
                      _vm._v(
                        " " +
                          _vm._s(this.errors.service[0]) +
                          "\n                         "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.close.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.__("globals.close")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "prevevnt",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    return _vm.convertQuestion.apply(null, arguments)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.__("questions.convert")))]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card p-1", attrs: { id: "loader" } }, [
      _c(
        "div",
        {
          staticClass: "spinner-border spinner-border-sm text-secondary m-auto",
          attrs: { role: "status" },
        },
        [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }